import React from "react";
import "./DeleteAccountModal.css";

const DeleteAccountModal = ({ isOpen, onClose, onConfirm, isLoading }) => {
  if (!isOpen) return null;

  return (
    <div className="delete-account-modal">
      <div className="delete-account-modal-content">
        <h2>Request Account Deletion</h2>
        <p>
          Are you sure you want to request deletion of your account? This action
          will:
        </p>
        <ul>
          <li>Submit a deletion request to administrators</li>
          <li>Mark your account for review</li>
          <li>
            Your account will remain active until an administrator approves the
            request
          </li>
        </ul>
        <p className="warning-text">
          This action cannot be undone. Once approved, all your data will be
          permanently deleted.
        </p>
        <div className="modal-actions">
          <button
            className="cancel-button"
            onClick={onClose}
            disabled={isLoading}
          >
            Cancel
          </button>
          <button
            className="confirm-button"
            onClick={onConfirm}
            disabled={isLoading}
          >
            {isLoading ? "Submitting Request..." : "Request Deletion"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default DeleteAccountModal;
